import React,{Component} from 'react';

import './AboutUs.css';

import { acri_st_logo, adwaiseo_logo, argans_logo, background_7, image1, image2, image3, ksat_logo, logo, serco_logo, solenix_logo, s_t_logo } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Partners from '@acri-tools/react-tools/components/Partners/Partners';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';

import about_image from './carte_site.png';


export default class AboutUs extends Component<{},{}>{

    render(){
        return (
        <Page 
            id="about-us"
            banner={{
                title: "about us",
                bannerImage: background_7,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('DAMPS - About Us') }</title>
                <meta 
                    name="description" 
                    content="Learn more about the DAMPS project and its contributors"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    <div className="row-2 about-us-container">
                        <div className="about-us-description">
                            <h1 className="title-3">Who Are We ?</h1>
                            <p className="description">
                                The industrial consortium is made of ACRI-ST (FR, Prime contractor), 
                                adwäisEO (LU), Serco (IT), ARGANS(UK), KSAT (NO), Solenix (DE) and S&T (NL)
                            </p>
                        </div>
                        <img alt="who we are map" className="who-are-we-image" src={about_image}/>
                    </div>

                    {/* <Partners
                        partners={[
                            {
                                name: "ACRI-ST",
                                link: "https://www.acri-st.fr/",
                                image: acri_st_logo,
                                description: "Prime contractor, responsible for Data Configuration and Change management, \
                                and Maintenance (DCCM), Pilot of Ad-hoc engineering services "
                            },
                            {
                                name: "AdwäisEO",
                                link: "https://www.adwaiseo.eu/en/home/",
                                image: adwaiseo_logo,
                                description: " Data Ingestion, Archiving and Extraction/Repatriation Services, Infrastructure provider"
                            },
                            {
                                name: "Serco",
                                link: "https://www.serco.com/",
                                image: serco_logo,
                                description: "Responsible for Data Information Service (DIS), Pilot of Data Consolidation and Processing service"
                            },
                            {
                                name: "ARGANS",
                                link: "https://argans.co.uk/",
                                image: argans_logo,
                                description: "Pilot of Processor System Integration service"
                            },
                            {
                                name: "KSAT",
                                link: "https://www.ksat.no/",
                                image: ksat_logo,
                                description: "Responsible for Ingestion Verification and Validation and DMS auditing"
                            },
                            {
                                name: "Solenix",
                                link: "https://www.solenix.ch/",
                                image: solenix_logo,
                                description: "Candidate for Ad hoc Engineering Services"
                            },
                            {
                                name: "S&T",
                                link: "https://www.stcorp.no/",
                                image: s_t_logo,
                                description: "Candidate for Processor System Integration Project"
                            },
                        ]}
                    /> */}


                </div>
            </div>
        </Page>
        );
    }

};
